export const LOADING = '[Loading]'

export const START_ACTION = `${LOADING} START_ACTION`
export const STOP_ACTION = `${LOADING} STOP_ACTION`
